import ListTableAction from './list-table-action'
import ListTableColumnTag from './list-table-column-tag'
import ListTableParticipationNum from './list-table-participation-num'
import ListTableNotApprovalNum from './list-table-not-approval-num'

export default {
  type: 'Table', // or Image
  columns: [{
    prop: 'name',
    label: '考试名称',
    showOverflowTooltip: true,
    minWidth: '200'
  }, {
    prop: 'showTags',
    label: '标签',
    // 自定义组件
    component: ListTableColumnTag,
    minWidth: '200'
  }, {
    prop: 'createrPerson',
    label: '创建人',
    minWidth: '120'
  }, {
    prop: 'createTime',
    label: '创建时间',
    minWidth: '160'
  }, {
    prop: 'participationNum',
    label: '参考人数',
    // 自定义组件
    component: ListTableParticipationNum,
    minWidth: '100'
  }, {
    prop: 'notApprovalNum',
    label: '未审数',
    // 自定义组件
    component: ListTableNotApprovalNum,
    minWidth: '100'
  }, {
    prop: 'action',
    label: '操作',
    // 自定义组件
    component: ListTableAction,
    width: '120',
    fixed: 'right'
  }]
}
